module.exports = __webpack_public_path__ + "static/img/3.219bc67.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/3.png
// module id = rnl6
// module chunks = 4